import React           from 'react';
import PropTypes       from 'prop-types';
import CloseX          from './img/x-reg.png';
import SocialMediaPost from "./SocialMediaPost";
import Helpers         from './Helpers';
import {AppConsumer}   from './App.context';
import ReactModal      from 'react-modal';

function ModalPost({itemData, isVisible, onClose, onNextClick, onPrevClick}) {
	const customModalStyles = {
		content: {
			top:             '50%',
			left:            '50%',
			right:           'auto',
			bottom:          'auto',
			marginRight:     '-50%',
			transform:       'translate(-50%, -50%)',
			backgroundColor: 'transparent',
			border:          'none',
			padding:         0,
			fontSize:        '16px',
		},
		overlay: {
			zIndex:          200,
			backgroundColor: 'rgba(255,255,255,0.8)',
		},
	};

	const onItemClick = (e) => {
		const halfX = window.innerWidth / 2;
		if (e.clientX >= halfX) {
			window.gtag('event', 'view_item', {
				'event_category': 'RoxxRacing',
				'event_label':    'social_post_next',
			});

			onNextClick();
		} else {
			window.gtag('event', 'view_item', {
				'event_category': 'RoxxRacing',
				'event_label':    'social_post_prev',
			});

			onPrevClick();
		}
	};

	return <ReactModal isOpen={isVisible}
	                   onRequestClose={onClose}
	                   style={customModalStyles}
	>
		<div className="roxxracing_socialpost-lightbox -cursor-pointer" onClick={onItemClick}>
			<div className="roxxracing_socialpost-lightbox--image-container">
				{itemData.imgSrcLarge && !itemData.videoSrc &&
				<img className="roxxracing_socialpost-lightbox--image" src={itemData.imgSrcLarge} alt="Social Media Post" />}
				{itemData.videoSrc && <video autoPlay="true" key={itemData.id} className="roxxracing_socialpost-lightbox--image">
					<source src={itemData.videoSrc} type="video/mp4" />
				</video>}
			</div>
			<img className="roxxracing_socialpost-lightbox--x" src={CloseX} alt="Exit" onClick={onClose} />
			<div className="roxxracing_socialpost-lightbox--content">
				<div className="roxxracing_socialpost-lightbox--text">
					<p className="roxxracing_socialpost-lightbox--title">{itemData.title}</p>
					{itemData.desc && <p className="roxxracing_socialpost-lightbox--infos">{itemData.desc}</p>}
				</div>
				<div className="roxxracing_socialpost-lightbox--data">
					<p className="roxxracing_socialpost-lightbox--posted"><b>Posted:</b> {itemData.date}</p>
					<p className="roxxracing_socialpost-lightbox--liked"><b>Gefällt:</b> {Helpers.formatNumber(itemData.likes)}
					</p>
				</div>
			</div>
		</div>
	</ReactModal>;
}

class SocialMediaPosts extends React.Component {
	constructor(props) {
		super(props);

		this.onClickElement  = this.onClickElement.bind(this);
		this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
		this.onModalClose    = this.onModalClose.bind(this);

		this.state = {
			itemsToShow:       props.initialItemsToShow,
			itemsToShowMobile: props.initialItemsToShowMobile,
		};
	}

	onClickElement(index) {
		window.gtag('event', 'view_item', {
			'event_category': 'RoxxRacing',
			'event_label':    'social_post',
		});

		this.setState({
			selectedIndex:  index,
			isModalVisible: true,
		});
	}

	onLoadMoreClick(e) {
		e.preventDefault();

		window.gtag('event', 'load_more', {
			'event_category': 'RoxxRacing',
			'event_label':    'social_post_load_more',
		});

		this.setState({
			itemsToShow:       this.state.itemsToShow + this.props.initialItemsToShow,
			itemsToShowMobile: this.state.itemsToShow + this.props.initialItemsToShow, // duplicate for the show button logic
		});
	}

	onModalClose() {
		this.setState({
			isModalVisible: false,
		});
	}

	render() {
		let detailDom;
		const {itemsToShow, itemsToShowMobile} = this.state;

		return (
			<AppConsumer>
				{({data}) => {
					if (typeof this.state.selectedIndex !== 'undefined') {
						const itemData        = data[this.state.selectedIndex];
						const onNextPostClick = () => {
							this.setState({
								selectedIndex: (this.state.selectedIndex + 1) % data.length,
							});
						};
						const onPrevPostClick = () => {
							this.setState({
								selectedIndex: ((this.state.selectedIndex - 1) + data.length) % data.length,
							});
						};

						detailDom = <ModalPost itemData={itemData}
						                       isVisible={this.state.isModalVisible}
						                       onClose={this.onModalClose}
						                       onNextClick={onNextPostClick}
						                       onPrevClick={onPrevPostClick}
						/>;
					}

					return <div className="roxxracing_socialpost-container">
						{detailDom}
						<div className="roxxracing_socialposts">
							{data.map((post, index) => {
								let postElement = null;

								if (index < itemsToShow) {
									postElement = <SocialMediaPost
										className={index >= itemsToShowMobile ? '-hide-mobile' : ''}
										date={post.date}
										desc={post.desc}
										imgSrc={post.imgSrc}
										index={index}
										orientation={post.orientation}
										origin={post.origin}
										key={'socialMediaPost' + index}
										likes={post.likes}
										title={post.title}
										onClickFn={this.onClickElement}
									/>
								}

								return postElement;
							})}
						</div>
						{this.props.useLoadMore && (itemsToShow < data.length) && <div className="roxxracing_socialposts-content--button-container">
							<a className="roxxracing_socialposts-content--button-link" onClick={this.onLoadMoreClick}>
								<div className="roxxracing_socialposts-content--button">Mehr sehen</div>
							</a>
						</div>}
					</div>;
				}}
			</AppConsumer>
		);
	}
}

SocialMediaPosts.propTypes = {
	initialItemsToShow:       PropTypes.number,
	initialItemsToShowMobile: PropTypes.number,
	useLoadMore:              PropTypes.bool,
};

SocialMediaPosts.defaultProps = {
	initialItemsToShow:       4,
	initialItemsToShowMobile: 1,
	useLoadMore:              false,
};

export default SocialMediaPosts;



// WEBPACK FOOTER //
// ./src/SocialMediaPosts.js